<template>
    <v-card>
        <v-expansion-panels flat :value="0">
            <v-expansion-panel class="pa-0">
                <v-expansion-panel-header :color="pantoneBlack" class="white--text">
                    <v-card-title  class="pa-0  text-family justify-center font-weight-black " hide-actions style="word-break: break-word;">Resumen de la transacción</v-card-title>
                    <!-- <template v-slot:actions>
                        <v-icon class="icon" right color="white">$expand</v-icon>
                    </template> -->
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-0">
                    <v-card-text>
                        <label class="text-family">* Antes de realizar tu pago, revisa que los datos estén correctos.</label>
                        <v-divider class="mt-2"></v-divider>
                        <v-expansion-panels flat >
                            <v-expansion-panel v-for="procedure in checkoutData" :key="'checkout'+procedure.id">
                                <v-expansion-panel-header class="px-0">
                                    <template v-slot:actions>
                                        <v-icon class="icon" left>$expand</v-icon>
                                    </template>
                                    <div class="header font-weight-bold">
                                        <div class="d-flex justify-space-between">
                                            <div class="text-family">{{ procedure.nombre_tramite }} </div>
                                            <div class="text-right text-family">{{ procedure.precio| currency }}</div>
                                        </div>
                                    </div>

                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="transaction-concepts">
                                    <v-simple-table dense fixed-header>
                                        <tbody>
                                        <tr
                                            v-for="concept in procedure.conceptos"
                                            :key="concept.id"
                                        >
                                            <td class="text-family">{{ concept.concepto }}</td>
                                            <td class="text-right text-family">{{ concept.precio| currency }}</td>
                                        </tr>
                                        </tbody>
                                    </v-simple-table>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                        <div class="grey lighten-4" v-if="checkoutItemsNumber > 5">
                            <v-btn
                                color="normal"
                                width="100%"
                                height="50"
                                text
                                x-small
                                class="text-family"
                                @click="onShowAllItems()"
                            >
                                Ver todos los trámites  ({{checkoutItemsNumber}} elementos)

                                <v-icon right class="float-right grey--text text--darken-2">
                                    fas fa-angle-down
                                </v-icon>

                            </v-btn>
                        </div>
                        <v-divider class="mt-4 mb-4"></v-divider>

                        <div class="d-flex justify-space-between text-h6">
                            <div class="text-family">Total a pagar</div>
                            <div>{{checkoutTotal| currency}}</div>
                        </div>
                        <template v-if="['pendiente', 'declinado'].includes(order.estatus)">
                            <v-card-actions >
                                <v-btn
                                    color="error"
                                    tile
                                    outlined
                                    class="mt-2 flex-fill text-family"
                                    @click="onCancelOrder()"
                                >
                                    Cancelar
                                </v-btn>
                                <v-btn
                                    color="success"
                                    tile
                                    class="mt-2 flex-fill text-family"
                                    @click="onPayOrder(), emitOnPayOrder()"
                                >
                                    Proceder pago
                                </v-btn>
                            </v-card-actions>
                        </template>
                        <template v-else-if="order.estatus === 'vencido'">
                            <v-btn
                                width="49%"
                                color="normal"
                                class="mt-2 mr-1  text-family"
                                large
                                disabled
                            >
                                {{order.estatus}}
                            </v-btn>
                            <v-btn
                                width="49%"
                                color="error"
                                class="mt-2 text-family"
                                large
                                @click="onCancelOrder ()"
                            >
                                Cancelar
                            </v-btn>
                        </template>
                        <v-btn
                            v-else
                            width="100%"
                            color="normal"
                            class="mt-2 mr-1  text-family"
                            large
                            disabled
                        >
                            {{order.estatus}}
                        </v-btn>

                    </v-card-text>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-card>
</template>

<script>
export default {
    name: "Checkout",
    props: [
        'checkoutData', 'checkoutTotal', 'checkoutItemsNumber', 'order',
        'onPayOrder', 'onCancelOrder', 'onShowAllItems'
    ],
    data(){
        return{
            pantone: '#B08C55',
            pantoneBlack: '#15212F',
        }
    },
    methods:{
        emitOnPayOrder(){
            this.$emit('emitOnPayOrder',1);
        }
    }
}
</script>

<style scoped>

.v-expansion-panel-header__icon{
    display: none;
}

</style>